var MoveToward = function (direction) {
    this.moveTo(undefined, undefined, direction);
    return this;
}
export default MoveToward;